import React from 'react';
import styled from 'styled-components';
import { renderStyledElementStyles } from '../../../../helpers';
import { ParagraphProps, StyledParagraph } from '../Paragraph';

const StyledPriceParagraph = styled(StyledParagraph)`
  white-space: nowrap;

  ${({ theme }) =>
    renderStyledElementStyles(
      theme,
      theme.module.dStyles.elements.priceParagraph,
    )}
  ${({ theme }) =>
    renderStyledElementStyles(
      theme,
      theme.module.vStyles.elements.priceParagraph,
    )}
`;

export type PriceParagraphProps = ParagraphProps;

export const PriceParagraph = ({ text }: PriceParagraphProps) => {
  return <StyledPriceParagraph>{text}</StyledPriceParagraph>;
};
